import React from "react";

/**
 * @typedef {Object} Property
 * @property {number} id
 * @property {string} image
 * @property {string} price
 * @property {string} type
 * @property {string} plan
 * @property {string} developer
 * @property {string} title
 * @property {string} location
 * @property {string} agent
 * @property {string} agentImg
 */

/** @type {Property[]} */

export const Projects = [
    {
        id: 1,
        image: "../Assets/e1.webp",
        image1: "../Assets/e2.webp",
        image2: "../Assets/e3.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 75/25",
        price: "AED 2.4 Mn",
        developer: "Emaar Properties",
        title: "Emaar Heights Country Club",
        url: "emaar_heights_country_club",
        location: "Emirates Road",
        agent: "Shiraz Khan",
        agentImg: "../Assets/agent_image.png",
        experience: "8+ Years of experience",
        project_name: "Emaar The Heights Country Club & Wellness",
    },
    {
        id: 2,
        image: "../Assets/card4.webp",
        image1: "../Assets/ci5.webp",
        image2: "../Assets/ci6.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 2.4 Mn",
        developer: "Emaar Properties",
        title: "Emaar Oasis",
        url: "emaar_oasis",
        location: "Dubailand",
        agent: "Kamil Nafis",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Oasis Dubai",
    },
    {
        id: 3,
        image: "../Assets/card5.webp",
        image1: "../Assets/ci7.webp",
        image2: "../Assets/ci8.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 50/50",
        price: "AED 5 Mn",
        developer: "H&H Developement",
        title: "Sunrise Valley",
        url: "sunrise_valley",
        location: "Nad Al Sheba",
        agent: "Sharuq Aziz",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Sunrise Valley Dubai",
    },
    {
        id: 4,
        image: "../Assets/card6.webp",
        image1: "../Assets/ci9.webp",
        image2: "../Assets/ci10.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 70/30",
        price: "AED 10.86 Mn",
        developer: "Emaar Properties",
        title: "Address Grand Downtown",
        url: "address_grand_downtown",
        location: "Downtown Dubai",
        agent: "Tejinder Singh",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Address Grand Downtown Dubai",
    },
    {
        id: 5,
        image: "../Assets/card7.webp",
        image1: "../Assets/ci11.webp",
        image2: "../Assets/ci12.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 6.2 Mn",
        developer: "Emaar Properties",
        title: "Emaar Grand Polo",
        url: "emaar_grand_polo",
        location: "Dubai Investment Park",
        agent: "Tejinder Singh",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Emaar Grand Polo Dubai",
    },
    {
        id: 6,
        image: "../Assets/card8.webp",
        image1: "../Assets/ci13.webp",
        image2: "../Assets/ci14.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 2.3 Mn",
        developer: "Emaar Properties",
        title: "Emaar Aurea",
        url: "emaar_aurea",
        location: "Mina Rashid Yachts & Marina",
        agent: "Muskan Jain",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Emaar Aurea Rym Dubai"
    },
    {
        id: 7,
        image: "../Assets/card9.webp",
        image1: "../Assets/ci15.webp",
        image2: "../Assets/ci16.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 50/50",
        price: "AED 2.5 Mn",
        developer: "Beyond Developments",
        title: "Beyond Hado",
        url: "beyond_hado",
        location: "Dubai Islands",
        agent: "Sharuq Aziz",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Beyond Hado Dubai",
    },
    {
        id: 8,
        image: "../Assets/card13.webp",
        image1: "../Assets/ci23.webp",
        image2: "../Assets/ci24.webp",
        type: "COMMERCIAL OFFICE & RETAIL",
        plan: "Payment Plan: 70/30",
        price: "AED 2 Mn",
        developer: "Danube Properties",
        title: "Danube Shahrukhz",
        url: "danube_shahrukhz",
        location: "Sheikh Zayed Road",
        agent: "Karan Dhand",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Danube Shahrukhz Dubai",
    },
    {
        id: 9,
        image: "../Assets/card17.webp",
        image1: "../Assets/ci31.webp",
        image2: "../Assets/ci32.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 9.5 Mn",
        developer: "Meraas",
        title: "Meraas Nad Al Sheba",
        url: "meraas_nad_al_sheba",
        location: "Nad Al Sheba",
        agent: "Kamil Nafis",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Nad Al Sheba Dubai",
    },
    {
        id: 10,
        image: "../Assets/card18.webp",
        image1: "../Assets/ci33.webp",
        image2: "../Assets/ci34.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 75/25",
        price: "AED 2.6 Mn",
        developer: "Damac",
        title: "Damac Islands",
        url: "damac_islands",
        location: "Dubailand, Dubai",
        agent: "Salman Khurshid",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Damac Islands Dubai",
    },
    {
        id: 11,
        image: "../Assets/card21.webp",
        image1: "../Assets/ci39.webp",
        image2: "../Assets/ci40.webp",
        type: "COMMERCIAL OFFICE",
        plan: "Payment Plan: 50/50",
        price: "AED 25 Mn",
        developer: "Omniyat",
        title: "Omniyat Lumena",
        url: "omniyat_lumena",
        location: "Business Bay",
        agent: "Kamil Nafis",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Omniyat Lumena Dubai",
    },
    {
        id: 12,
        image: "../Assets/card23.webp",
        image1: "../Assets/ci43.webp",
        image2: "../Assets/ci44.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 2.7 Mn",
        developer: "Emaar Properties",
        title: "Emaar Beach Front",
        url: "emaar_beach_front",
        location: "Dubai Harbour",
        agent: "Kamil Nafis",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Beach Front Dubai",
    },
    {
        id: 13,
        image: "../Assets/card24.webp",
        image1: "../Assets/ci45.webp",
        image2: "../Assets/ci46.webp",
        type: "APARTMENT & DUPLEX",
        plan: "Payment Plan: 75/25",
        price: "AED 2.62 Mn",
        developer: "Meraas",
        title: "Meraas City Walk Crestlane",
        url: "meraas_citywalk_crestlane",
        location: "City Walk",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Citywalk Crestlane Dubai",
    },
    {
        id: 14,
        image: "../Assets/card25.webp",
        image1: "../Assets/ci47.webp",
        image2: "../Assets/ci48.webp",
        type: "VILLA",
        plan: "Payment Plan: 40/60",
        price: "AED 2.07 Mn",
        developer: "Sanzen",
        title: "Sanzen Sukoon",
        url: "sanzen_sukoon",
        location: "Sharjah",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Sanzen Sukoon Sharjah",
    },
    {
        id: 15,
        image: "../Assets/card29.webp",
        image1: "../Assets/ci55.webp",
        image2: "../Assets/ci56.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 7.09 Mn",
        developer: "Emaar Properties",
        title: "Emaar The Valley",
        url: "emaar_the_valley",
        location: "Emaar The Valley",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Rivera Valley Dubai",
    },
    {
        id: 16,
        image: "../Assets/card32.webp",
        image1: "../Assets/ci61.webp",
        image2: "../Assets/ci62.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 2.7 Mn",
        developer: "Emaar Properties",
        title: "Emaar Avarra by Palace",
        url: "emaar_avarra_by_palace",
        location: "Business Bay",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Avarra By Palace Dubai",
    },
    {
        id: 17,
        image: "../Assets/card33.webp",
        image1: "../Assets/ci63.webp",
        image2: "../Assets/ci64.webp",
        type: "APARTMENT & TOWNHOUSE & VILLA",
        plan: "Payment Plan: 70/30",
        price: "AED 2.5 Mn",
        developer: "Nakheel",
        title: "Palm Central Residences",
        url: "palm_central_residences",
        location: "Plam Jebel Ali",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Palm Central Residences Dubai",
    },
    {
        id: 18,
        image: "../Assets/card28.webp",
        image1: "../Assets/ci53.webp",
        image2: "../Assets/ci54.webp",
        type: "APARTMENT & PENTHOUSE & DUPLEX",
        plan: "Payment Plan: 60/40",
        price: "AED 14.2 Mn",
        developer: "Meraas",
        title: "Meraas Solaya Jumeirah",
        url: "meraas_solaya_jumeirah",
        location: "La Mer, Jumeirah",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Solaya Dubai",
    },
    {
        id: 19,
        image: "../Assets/card37.webp",
        image1: "../Assets/ci71.webp",
        image2: "../Assets/ci72.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 25 Mn",
        developer: "Nakheel",
        title: "Palm Jebel Ali",
        url: "palm_jebel_ali",
        location: "Palm Jebel Ali",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Palm Jebel Ali Dubai",
    },
    {
        id: 20,
        image: "../Assets/card38.webp",
        image1: "../Assets/ci73.webp",
        image2: "../Assets/ci74.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 5.6 Mn",
        developer: "Nakheel",
        title: "Nakheel Bay Villas",
        url: "nakheel_bay_villa",
        location: "Dubai Islands",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Nakheel Bay Villas Dubai",
    },
    {
        id: 21,
        image: "../Assets/card40.webp",
        image1: "../Assets/ci77.webp",
        image2: "../Assets/ci78.webp",
        type: "APARTMENT & PENTHOUSE",
        plan: "Payment Plan: 75/25",
        price: "AED 2.1 Mn",
        developer: "Meraas",
        title: "Meraas Atelis",
        url: "meraas_atelis",
        location: "Dubai Design District (D3)",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Atelis Dubai",
    },
]


export const LuxuryProjects = [
    {
        id: 1,
        image: "../Assets/card22.webp",
        image1: "../Assets/ci41.webp",
        image2: "../Assets/ci42.webp",
        type: "APARTMENT & VILLA",
        plan: "Payment Plan: 60/40",
        price: "AED 1.18 Mn",
        developer: "Sobha Realty",
        title: "Sobha Siniya Islands",
        url: "sobha_siniya_islands",
        location: "Umm Al Quwain",
        agent: "Shahalam Khan",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Sobha Siniya Dubai",
    },
    {
        id: 2,
        image: "../Assets/card20.webp",
        image1: "../Assets/ci37.webp",
        image2: "../Assets/ci38.webp",
        type: "COMMERCIAL OFFICE & RETAIL",
        plan: "Payment Plan: 45/55",
        price: "AED 1.99 Mn",
        developer: "Al Marwan",
        title: "District 11",
        url: "district_11",
        location: "Sharjah",
        agent: "Naseera Mehmood",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Al Marwan District 11",
    },
    {
        id: 3,
        image: "../Assets/card19.webp",
        image1: "../Assets/ci35.webp",
        image2: "../Assets/ci36.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 40/60",
        price: "AED 1.65 Mn",
        developer: "Alef Group",
        title: "Alef Palace Residences",
        url: "alef_palace_residences",
        location: "Al Mamsha",
        agent: "Naseera Mehmood",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Palace Residences Al Mamsha",
    },
    {
        id: 4,
        image: "../Assets/card16.webp",
        image1: "../Assets/ci29.webp",
        image2: "../Assets/ci30.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 70/30",
        price: "AED 1.5 Mn",
        developer: "Binghatti Properties",
        title: "Bingahatti Pinnacle",
        url: "bingahatti_pinnacle",
        location: "Al Jaddaf",
        agent: "Ankita Bora",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Binghatti Pinnacle Dubai",
    },
    {
        id: 5,
        image: "../Assets/card15.webp",
        image1: "../Assets/ci27.webp",
        image2: "../Assets/ci28.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 40/60",
        price: "AED 1.27 Mn",
        developer: "Sobha Realty",
        title: "Sobha Hartland", 
        url: "sobha_hartland",
        location: "Nad Al Sheba",
        agent: "Shahalam Khan",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Sobha Hartland 2 Dubai",
    },
    {
        id: 6,
        image: "../Assets/card14.webp",
        image1: "../Assets/ci25.webp",
        image2: "../Assets/ci26.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 60/40",
        price: "AED 820 K",
        developer: "Binghatti Properties",
        title: "Bingahatti Cullinan",
        url: "bingahatti_cullinan", 
        location: "Al Jaddaf",
        agent: "Fatemeh Yousuf",
        agentImg: "../Assets/agent_image.png",
        experience: "2.5+ Years of experience",
        project_name: "Binghatti Cullinan Dubai",
    },
    {
        id: 7,
        image: "../Assets/card12.webp",
        image1: "../Assets/ci21.webp",
        image2: "../Assets/ci22.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 70/30",
        price: "AED 800 K",
        developer: "Danube Properties",
        title: "Danube Timez",
        url: "danube_timez", 
        location: "Dubai Silicon Oasis",
        agent: "Karan Dhand",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Danube Timez Dubai",
    },
    {
        id: 8,
        image: "../Assets/card11.webp",
        image1: "../Assets/ci19.webp",
        image2: "../Assets/ci20.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 50/50",
        price: "AED 685 K",
        developer: "Deyaar Developments",
        title: "Deyaar Park Five",
        url: "deyaar_park_five", 
        location: "Dubai Production City",
        agent: "Asad Qureshi",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Deyaar Parkfive Dubai",
    },
    {
        id: 9,
        image: "../Assets/card2.webp",
        image1: "../Assets/ci3.webp",
        image2: "../Assets/ci4.webp",
        type: "APARTMENT",  
        plan: "Payment Plan: 75/25",
        price: "AED 680 K",
        developer: "Damac",
        title: "Damac Islands Apartments",
        url: "damac_islands_apartments", 
        location: "Dubailand, Dubai",
        agent: "Salman Khurshid",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Damac Islands Apartments",
    },
    {
        id: 10,
        image: "../Assets/card10.webp",
        image1: "../Assets/ci17.webp",
        image2: "../Assets/ci18.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 45/55",
        price: "AED 1.6 Mn",
        developer: "Arada Developments",
        title: "Arada Masaar",
        url: "arada_masaar", 
        location: "Sharjah",
        agent: "Naseera Mehmood",
        agentImg: "../Assets/agent_image.png",
        experience: "4+ Years of experience",
        project_name: "Arada Masar 2.0 Dubai",
    },
    {
        id: 11,
        image: "../Assets/card1.webp",
        image1: "../Assets/ci1.webp",
        image2: "../Assets/ci2.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 70/30",
        price: "AED 1.7 Mn",
        developer: "Binghatti Properties",
        title: "Binghatti Mercedes Benz Places Meydan",
        url: "binghatti_mercedes_benz_places_meydan", 
        location: "Meydan, Dubai",
        agent: "Ankita Bora",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Binghatti Mercedes Benz Places",
    },
    {
        id: 12,
        image: "../Assets/e1.webp",
        image1: "../Assets/e2.webp",
        image2: "../Assets/e3.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 75/25",
        price: "AED 2.4 Mn",
        developer: "Emaar Properties",
        title: "Emaar Heights Country Club",
        url: "emaar_heights_country_club",
        location: "Emirates Road",
        agent: "Shiraz Khan",
        agentImg: "../Assets/agent_image.png",
        experience: "8+ Years of experience",
        project_name: "Emaar The Heights Country Club & Wellness",
    },
    {
        id: 13,
        image: "../Assets/card5.webp",
        image1: "../Assets/ci7.webp",
        image2: "../Assets/ci8.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 50/50",
        price: "AED 5 Mn",
        developer: "H&H Developement",
        title: "Sunrise Valley",
        url: "sunrise_valley",
        location: "Nad Al Sheba",
        agent: "Sharuq Aziz",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Sunrise Valley Dubai",
    },
    {
        id: 14,
        image: "../Assets/card7.webp",
        image1: "../Assets/ci11.webp",
        image2: "../Assets/ci12.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 6.2 Mn",
        developer: "Emaar Properties",
        title: "Emaar Grand Polo",
        url: "emaar_grand_polo",
        location: "Dubai Investment Park",
        agent: "Tejinder Singh",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Emaar Grand Polo Dubai"
    },
    {
        id: 15,
        image: "../Assets/card9.webp",
        image1: "../Assets/ci15.webp",
        image2: "../Assets/ci16.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 50/50",
        price: "AED 2.5 Mn",
        developer: "Beyond Developments",
        title: "Beyond Hado",
        url: "beyond_hado",
        location: "Dubai Islands",
        agent: "Sharuq Aziz",
        agentImg: "../Assets/agent_image.png",
        experience: "5+ Years of experience",
        project_name: "Beyond Hado Dubai",
    },
    {
        id: 16,
        image: "../Assets/card13.webp",
        image1: "../Assets/ci23.webp",
        image2: "../Assets/ci24.webp",
        type: "COMMERCIAL OFFICE & RETAIL",
        plan: "Payment Plan: 70/30",
        price: "AED 2 Mn",
        developer: "Danube Properties",
        title: "Danube Shahrukhz",
        url: "danube_shahrukhz",
        location: "Sheikh Zayed Road",
        agent: "Karan Dhand",
        agentImg: "../Assets/agent_image.png",
        experience: "3+ Years of experience",
        project_name: "Danube Shahrukhz Dubai",
    },
    {
        id: 17,
        image: "../Assets/card21.webp",
        image1: "../Assets/ci39.webp",
        image2: "../Assets/ci40.webp",
        type: "COMMERCIAL OFFICE",
        plan: "Payment Plan: 50/50",
        price: "AED 25 Mn",
        developer: "Omniyat",
        title: "Omniyat Lumena",
        url: "omniyat_lumena",
        location: "Business Bay",
        agent: "Kamil Nafis",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Omniyat Lumena Dubai",
    },
    {
        id: 18,
        image: "../Assets/card24.webp",
        image1: "../Assets/ci45.webp",
        image2: "../Assets/ci46.webp",
        type: "APARTMENT & DUPLEX",
        plan: "Payment Plan: 75/25",
        price: "AED 2.62 Mn",
        developer: "Meraas",
        title: "Meraas City Walk Crestlane",
        url: "meraas_citywalk_crestlane",
        location: "City Walk",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Citywalk Crestlane Dubai",
    },
    {
        id: 19,
        image: "../Assets/card25.webp",
        image1: "../Assets/ci47.webp",
        image2: "../Assets/ci48.webp",
        type: "VILLA",
        plan: "Payment Plan: 40/60",
        price: "AED 2.07 Mn",
        developer: "Sanzen",
        title: "Sanzen Sukoon",
        url: "sanzen_sukoon",
        location: "Sharjah",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Sanzen Sukoon Sharjah",
    },
    {
        id: 20,
        image: "../Assets/card26.webp",
        image1: "../Assets/ci49.webp",
        image2: "../Assets/ci50.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 70/30",
        price: "AED 460 K",
        developer: "BT Properties",
        title: "BT properties Waada",
        url: "bt_properties_waada",
        location: "Dubai South",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Waada By BT Properties",
    },
    {
        id: 21,
        image: "../Assets/card27.webp",
        image1: "../Assets/ci51.webp",
        image2: "../Assets/ci52.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 40/60",
        price: "AED 850 K",
        developer: "Purvanchal",
        title: "Purvanchal Triana Residences Al-satwa",
        url: "purvanchal_triana_residences",
        location: "Jumeirah Garden City",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Purvanchal Triana Residences",
    },
    {
        id: 22,
        image: "../Assets/card28.webp",
        image1: "../Assets/ci53.webp",
        image2: "../Assets/ci54.webp",
        type: "APARTMENT & PENTHOUSE & DUPLEX",
        plan: "Payment Plan: 60/40",
        price: "AED 14.2 Mn",
        developer: "Meraas",
        title: "Meraas Solaya Jumeirah",
        url: "meraas_solaya_jumeirah",
        location: "La Mer, Jumeirah",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Solaya Dubai",
    },
    {
        id: 23,
        image: "../Assets/card29.webp",
        image1: "../Assets/ci55.webp",
        image2: "../Assets/ci56.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 7.09 Mn",
        developer: "Emaar Properties",
        title: "Emaar The Valley",
        url: "emaar_the_valley",
        location: "Emaar The Valley",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Rivera Valley Dubai",
    },
    {
        id: 24,
        image: "../Assets/card30.webp",
        image1: "../Assets/ci57.webp",
        image2: "../Assets/ci58.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 1.6 Mn",
        developer: "Emaar Properties",
        title: "Emaar Hills Estate",
        url: "emaar_hills_estate",
        location: "Dubai Hills Estate",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Dubai Hills Estate",
    },
    {
        id: 25,
        image: "../Assets/card31.webp",
        image1: "../Assets/ci59.webp",
        image2: "../Assets/ci60.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 50/50",
        price: "AED 1.81 Mn",
        developer: "Emaar Properties",
        title: "Emaar Creek Harbour",
        url: "emaar_creek_harbour",
        location: "Dubai Creek Harbour",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Dubai Creek Harbour",
    },
    {
        id: 26,
        image: "../Assets/card32.webp",
        image1: "../Assets/ci61.webp",
        image2: "../Assets/ci62.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 2.7 Mn",
        developer: "Emaar Properties",
        title: "Emaar Avarra by Palace",
        url: "emaar_avarra_by_palace",
        location: "Business Bay",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Emaar Avarra By Palace Dubai",
    },
    {
        id: 27,
        image: "../Assets/card33.webp",
        image1: "../Assets/ci63.webp",
        image2: "../Assets/ci64.webp",
        type: "APARTMENT & TOWNHOUSE & VILLA",
        plan: "Payment Plan: 70/30",
        price: "AED 2.5 Mn",
        developer: "Nakheel",
        title: "Palm Central Residences",
        url: "palm_central_residences",
        location: "Plam Jebel Ali",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Palm Central Residences Dubai",
    },  
    {
        id: 28,
        image: "../Assets/card34.webp",
        image1: "../Assets/ci65.webp",
        image2: "../Assets/ci66.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        price: "AED 570 K",
        developer: "Azizi",
        title: "Azizi Milan",
        url: "azizi_milan",
        location: "Dubailand",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Azizi Milan Dubai",
    },
    {
        id: 29,
        image: "../Assets/card35.webp",
        image1: "../Assets/ci67.webp",
        image2: "../Assets/ci68.webp",
        type: "APARTMENT & PENTHOUSE",
        plan: "Payment Plan: 70/30",
        price: "AED 1.3 Mn",
        developer: "Danube Properties",
        title: "Danube Breez",
        url: "danube_breez",
        location: "Dubai Maritime City",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Danube Breez Dubai",
    },
    {
        id: 30,
        image: "../Assets/card36.webp",
        image1: "../Assets/ci69.webp",
        image2: "../Assets/ci70.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 40/60",
        price: "AED 699 K",
        developer: "Alef Group",
        title: "Alef Olfah Sharjah",
        url: "alef_olfah_sharjah",
        location: "Sharjah",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Alef Olfah Sharjah",
    },
    {
        id: 31,
        image: "../Assets/card37.webp",
        image1: "../Assets/ci71.webp",
        image2: "../Assets/ci72.webp",
        type: "VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 25 Mn",
        developer: "Nakheel",
        title: "Palm Jebel Ali",
        url: "palm_jebel_ali",
        location: "Palm Jebel Ali",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Palm Jebel Ali Dubai",
    },
    {
        id: 32,
        image: "../Assets/card38.webp",
        image1: "../Assets/ci73.webp",
        image2: "../Assets/ci74.webp",
        type: "TOWNHOUSE & VILLA",
        plan: "Payment Plan: 80/20",
        price: "AED 5.6 Mn",
        developer: "Nakheel",
        title: "Nakheel Bay Villas",
        url: "nakheel_bay_villa",
        location: "Dubai Islands",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Nakheel Bay Villas Dubai",
    },
    {
        id: 33,
        image: "../Assets/card39.webp",
        image1: "../Assets/ci75.webp",
        image2: "../Assets/ci76.webp",
        type: "APARTMENT",
        plan: "Payment Plan: 30/70",
        price: "AED 1.2 Mn",
        developer: "London Gate",
        title: "Franck Muller Yachting",
        url: "franck_muller_yachting",
        location: "Dubai Maritime City",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Franck Muller Yachting",
    },
    {
        id: 34,
        image: "../Assets/card40.webp",
        image1: "../Assets/ci77.webp",
        image2: "../Assets/ci78.webp",
        type: "APARTMENT & PENTHOUSE",
        plan: "Payment Plan: 75/25",
        price: "AED 2.1 Mn",
        developer: "Meraas",
        title: "Meraas Atelis",
        url: "meraas_atelis",
        location: "Dubai Design District (D3)",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Meraas Atelis Dubai",
    },
];